import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: 'transactionsApi',
  baseQuery,
  endpoints: builder => ({
    getTransactions: builder.query<any, any>({
      query: filters => ({
        url: endpoints.TRANSACTIONS,
        method: 'GET',
        params: filters,
      }),
    }),
  }),
});

export const { actions: TransactionsActions } = slice;

export const useTransactionsSlice = () => {
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  //  useInjectSaga({ key: slice.name, saga: Saga });
  return {
    actions: TransactionsActions,
    useGetTransactionsListQuery: api.useLazyGetTransactionsQuery,
  };
};
